module.exports = __webpack_public_path__ + "img/Snow.68e7ab85.png";